export default __webpack_public_path__ + "static/media/WhatsApp Image 2022-05-18 at 12.38.16.5354fb88.jpeg";